/* eslint-disable */
import dicts from './example'

export const branchConferenceCols = [
  {
    title: '会议名称',
    key: 'conferenceName',
    tooltip: true,
    width: 240,
  },
  {
    title: '会议类型',
    slot: 'conferenceType',
    tooltip: true,
    width: 140,
  },
  {
    title: '会议时间',
    key: 'conferenceTime',
    tooltip: true,
    width: 150,
  },
  {
    title: '会议地点',
    slot: 'placeType',
    width: 100,
  },
  {
    title: '党员之家',
    key: 'homeName',
    width: 160,
    tooltip: true,
  },
  {
    title: '会议主题',
    key: 'subjectName',
    width: 240,
    tooltip: true,
  },
  {
    title: '会议主要内容',
    key: 'content',
    width: 240,
    tooltip: true,
  },
  {
    title: '特邀人士',
    key: 'invitation',
    width: 120,
    tooltip: true,
  },
  {
    title: '应到人数',
    key: 'shouldCount',
    width: 100,
  },
  {
    title: '实到人数',
    key: 'actualCount',
    width: 100,
  },
  {
    title: '照片附件',
    slot: 'fileUrl',
    width: 200,
  },
  {
    title: '记录人',
    key: 'recordUser',
    width: 100,
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center'
  },
]

export const branchConferenceForm = {
  attrs: {
    labelWidth: '180px',
    'label-position': 'left',
    rules: {
      conferenceType: [
        {
          required: true,
          message: '请选择会议类型',
          trigger: 'change',
        },
      ],
      conferenceTime: [
        {
          required: true,
          message: '请选择会议时间',
          trigger: 'change',
        },
      ],
      placeType: [
        {
          required: true,
          message: '请选择会议地点',
          trigger: 'change',
        },
      ],
      homeUid: [
        {
          required: true,
          message: '请选择党员之家',
          trigger: 'change',
        },
      ],
      subject: [
        {
          required: true,
          message: '请选择会议主题',
          trigger: 'change',
        },
      ],
      content: [
        {
          required: true,
          message: '请输入会议主要内容',
          trigger: 'blur',
        },
      ],
      invitation: [
        { required: true, message: '请输入特邀人士', trigger: 'blur' },
      ],
      shouldCount: [
        { required: true, message: '请输入应到人数', trigger: 'blur' },
      ],
      actualCount: [
        { required: true, message: '请输入实到人数', trigger: 'blur' },
      ],
      // fileUrl: [
      //   {
      //     required: true,
      //     message: '请选择照片附件',
      //     trigger: 'change',
      //   },
      // ],
      recordUser: [
        { required: true, message: '请输入记录人', trigger: 'blur' },
      ],
    },
  },
  items: [
    {
      label: '会议名称',
      prop: 'conferenceName',
      maxlength: 50,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '会议类型',
      prop: 'conferenceType',
      options: [
        { label: '支部委员会会议', value: 1 },
        { label: '支部党员大会', value: 2 },
        { label: '支部民主生活会', value: 3 },
        { label: '其他', value: 4 },
      ],
    },
    {
      type: 'datepicker',
      label: '会议时间',
      prop: 'conferenceTime',
      clearable: true,
      format: 'yyyy-MM-dd',
      dateType: 'date',
      attrs: {
        valueFormat: 'yyyy-MM-dd'
      }
    },
    {
      type: 'select',
      label: '会议地点',
      prop: 'placeType',
      options: [
        { label: '党员之家', value: 1 },
        { label: '其他地点', value: 2 },
        { label: '线上', value: 3 },
      ],
    },
    {
      type: 'select-remote',
      label: '党员之家',
      prop: 'homeUid',
      filterable: true,
      remote: true,
      paramsKey: 'keyword',
      params: {
        // projectUid: cache.get('PROJECTUID') || '',
        // branchUid: cache.get('BRANCHID') || '',
        // from: 1,
        // size: 10,
      },
      remoteAction: 'getHomeListApi',
      labelName: 'name',
      valueName: 'uid',
      hidden: true,
    },
    {
      type: 'select',
      label: '会议主题',
      prop: 'subject',
      multiple: true,
      options: dicts.subject(),
    },
    {
      type: 'textarea',
      label: '会议主要内容',
      prop: 'content',
      maxlength: 500,
      showWordLimit: true,
      rows: 6,
    },
    {
      label: '特邀人士',
      prop: 'invitation',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '应到人数',
      prop: 'shouldCount',
      type: 'input-number',
      attrs: {
        min: 0,
        max: 999,
        precision: 0
      },
    },
    {
      label: '实到人数',
      prop: 'actualCount',
      type: 'input-number',
      attrs: {
        min: 0,
        max: 999,
        precision: 0
      },
    },
    {
      label: '记录人',
      prop: 'recordUser',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'file-upload-imgVideo-mutiple',
      label: '照片附件',
      prop: 'fileUrl',
      noLimitSize: true
    }
  ],
}